import { MicrophoneIcon as solidMicrophoneIcon, SpeakerWaveIcon as solidSpeakerWaveIcon, SpeakerXMarkIcon as solidSpeakerXMarkIcon, Cog6ToothIcon as solidCog6ToothIcon, ExclamationCircleIcon as solidExclamationCircleIcon, NewspaperIcon as solidNewspaperIcon, IdentificationIcon as solidIdentificationIcon, PrinterIcon as solidPrinterIcon, DocumentCheckIcon as solidDocumentCheckIcon, MagnifyingGlassIcon as solidMagnifyingGlassIcon, PaperClipIcon as solidPaperClipIcon, ChevronUpIcon as solidChevronUpIcon, BriefcaseIcon as solidBriefcaseIcon, ArrowRightIcon as solidArrowRightIcon, DocumentDuplicateIcon as solidDocumentDuplicateIcon, PencilIcon as solidPencilIcon, EllipsisHorizontalCircleIcon as solidEllipsisHorizontalCircleIcon, InformationCircleIcon as solidInformationCircleIcon, ShieldCheckIcon as solidShieldCheckIcon, PaperAirplaneIcon as solidPaperAirplaneIcon, MapPinIcon as solidMapPinIcon, CameraIcon as solidCameraIcon, PhoneIcon as solidPhoneIcon, HomeIcon as solidHomeIcon, StarIcon as solidStarIcon, ClockIcon as solidClockIcon, EyeSlashIcon as solidEyeSlashIcon, ArrowLeftIcon as solidArrowLeftIcon, EnvelopeIcon as solidEnvelopeIcon, BellIcon as solidBellIcon, ClipboardDocumentCheckIcon as solidClipboardDocumentCheckIcon, UserIcon as solidUserIcon, UserCircleIcon as solidUserCircleIcon, ChevronLeftIcon as solidChevronLeftIcon, ChevronRightIcon as solidChevronRightIcon, ChevronDownIcon as solidChevronDownIcon, BookOpenIcon as solidBookOpenIcon, PencilSquareIcon as solidPencilSquareIcon, TrashIcon as solidTrashIcon, ArchiveBoxXMarkIcon as solidArchiveBoxXMarkIcon, PhotoIcon as solidPhotoIcon, EyeIcon as solidEyeIcon, ChatBubbleLeftEllipsisIcon as solidChatBubbleLeftEllipsisIcon, ClipboardDocumentListIcon as solidClipboardDocumentListIcon, CalendarDaysIcon as solidCalendarDaysIcon, EllipsisVerticalIcon as solidEllipsisVerticalIcon, DocumentTextIcon as solidDocumentTextIcon, CheckCircleIcon as solidCheckCircleIcon, CheckIcon as solidCheckIcon, Bars3CenterLeftIcon as solidBars3CenterLeftIcon, MoonIcon as solidMoonIcon, LockClosedIcon as solidLockClosedIcon, XMarkIcon as solidXMarkIcon, DocumentMagnifyingGlassIcon as solidDocumentMagnifyingGlassIcon } from "@heroicons/vue/24/solid";
import { MicrophoneIcon as outlineMicrophoneIcon, SpeakerWaveIcon as outlineSpeakerWaveIcon, SpeakerXMarkIcon as outlineSpeakerXMarkIcon, Cog6ToothIcon as outlineCog6ToothIcon, ExclamationCircleIcon as outlineExclamationCircleIcon, NewspaperIcon as outlineNewspaperIcon, IdentificationIcon as outlineIdentificationIcon, PrinterIcon as outlinePrinterIcon, DocumentCheckIcon as outlineDocumentCheckIcon, MagnifyingGlassIcon as outlineMagnifyingGlassIcon, PaperClipIcon as outlinePaperClipIcon, ChevronUpIcon as outlineChevronUpIcon, BriefcaseIcon as outlineBriefcaseIcon, ArrowRightIcon as outlineArrowRightIcon, DocumentDuplicateIcon as outlineDocumentDuplicateIcon, PencilIcon as outlinePencilIcon, EllipsisHorizontalCircleIcon as outlineEllipsisHorizontalCircleIcon, InformationCircleIcon as outlineInformationCircleIcon, ShieldCheckIcon as outlineShieldCheckIcon, PaperAirplaneIcon as outlinePaperAirplaneIcon, MapPinIcon as outlineMapPinIcon, CameraIcon as outlineCameraIcon, PhoneIcon as outlinePhoneIcon, HomeIcon as outlineHomeIcon, StarIcon as outlineStarIcon, ClockIcon as outlineClockIcon, EyeSlashIcon as outlineEyeSlashIcon, ArrowLeftIcon as outlineArrowLeftIcon, EnvelopeIcon as outlineEnvelopeIcon, BellIcon as outlineBellIcon, ClipboardDocumentCheckIcon as outlineClipboardDocumentCheckIcon, UserIcon as outlineUserIcon, UserCircleIcon as outlineUserCircleIcon, ChevronLeftIcon as outlineChevronLeftIcon, ChevronRightIcon as outlineChevronRightIcon, ChevronDownIcon as outlineChevronDownIcon, BookOpenIcon as outlineBookOpenIcon, PencilSquareIcon as outlinePencilSquareIcon, TrashIcon as outlineTrashIcon, ArchiveBoxXMarkIcon as outlineArchiveBoxXMarkIcon, PhotoIcon as outlinePhotoIcon, EyeIcon as outlineEyeIcon, ChatBubbleLeftEllipsisIcon as outlineChatBubbleLeftEllipsisIcon, ClipboardDocumentListIcon as outlineClipboardDocumentListIcon, CalendarDaysIcon as outlineCalendarDaysIcon, EllipsisVerticalIcon as outlineEllipsisVerticalIcon, DocumentTextIcon as outlineDocumentTextIcon, CheckCircleIcon as outlineCheckCircleIcon, CheckIcon as outlineCheckIcon, Bars3CenterLeftIcon as outlineBars3CenterLeftIcon, MoonIcon as outlineMoonIcon, LockClosedIcon as outlineLockClosedIcon, XMarkIcon as outlineXMarkIcon, DocumentMagnifyingGlassIcon as outlineDocumentMagnifyingGlassIcon, UserGroupIcon as outlineUserGroupIcon } from "@heroicons/vue/24/outline";

export const solidIcons = {
  BellIcon: solidBellIcon,
  ClipboardDocumentCheckIcon: solidClipboardDocumentCheckIcon,
  UserIcon: solidUserIcon,
  UserCircleIcon: solidUserCircleIcon,
  ChevronLeftIcon: solidChevronLeftIcon,
  ChevronRightIcon: solidChevronRightIcon,
  ChevronDownIcon: solidChevronDownIcon,
  BookOpenIcon: solidBookOpenIcon,
  PencilSquareIcon: solidPencilSquareIcon,
  TrashIcon: solidTrashIcon,
  ArchiveBoxXMarkIcon: solidArchiveBoxXMarkIcon,
  PhotoIcon: solidPhotoIcon,
  EyeIcon: solidEyeIcon,
  ChatBubbleLeftEllipsisIcon: solidChatBubbleLeftEllipsisIcon,
  ClipboardDocumentListIcon: solidClipboardDocumentListIcon,
  CalendarDaysIcon: solidCalendarDaysIcon,
  EllipsisVerticalIcon: solidEllipsisVerticalIcon,
  DocumentTextIcon: solidDocumentTextIcon,
  CheckCircleIcon: solidCheckCircleIcon,
  CheckIcon: solidCheckIcon,
  Bars3CenterLeftIcon: solidBars3CenterLeftIcon,
  MoonIcon: solidMoonIcon,
  LockClosedIcon: solidLockClosedIcon,
  XMarkIcon: solidXMarkIcon,
  DocumentMagnifyingGlassIcon: solidDocumentMagnifyingGlassIcon,
  EnvelopeIcon: solidEnvelopeIcon,
  ArrowLeftIcon: solidArrowLeftIcon,
  EyeSlashIcon: solidEyeSlashIcon,
  HomeIcon: solidHomeIcon,
  StarIcon: solidStarIcon,
  ClockIcon: solidClockIcon,
  PhoneIcon: solidPhoneIcon,
  CameraIcon: solidCameraIcon,
  MapPinIcon: solidMapPinIcon,
  PaperAirplaneIcon: solidPaperAirplaneIcon,
  ShieldCheckIcon: solidShieldCheckIcon,
  InformationCircleIcon: solidInformationCircleIcon,
  EllipsisHorizontalCircleIcon: solidEllipsisHorizontalCircleIcon,
  PencilIcon: solidPencilIcon,
  DocumentDuplicateIcon: solidDocumentDuplicateIcon,
  ArrowRightIcon: solidArrowRightIcon,
  BriefcaseIcon: solidBriefcaseIcon,
  ChevronUpIcon: solidChevronUpIcon,
  PaperClipIcon: solidPaperClipIcon,
  MagnifyingGlassIcon: solidMagnifyingGlassIcon,
  DocumentCheckIcon: solidDocumentCheckIcon,
  PrinterIcon: solidPrinterIcon,
  IdentificationIcon: solidIdentificationIcon,
  NewspaperIcon: solidNewspaperIcon,
  ExclamationCircleIcon: solidExclamationCircleIcon,
  Cog6ToothIcon: solidCog6ToothIcon,
  SpeakerWaveIcon: solidSpeakerWaveIcon,
  SpeakerXMarkIcon: solidSpeakerXMarkIcon,
  MicrophoneIcon: solidMicrophoneIcon,
};

export const outlineIcons = {
  BellIcon: outlineBellIcon,
  ClipboardDocumentCheckIcon: outlineClipboardDocumentCheckIcon,
  UserIcon: outlineUserIcon,
  UserCircleIcon: outlineUserCircleIcon,
  ChevronLeftIcon: outlineChevronLeftIcon,
  ChevronRightIcon: outlineChevronRightIcon,
  ChevronDownIcon: outlineChevronDownIcon,
  BookOpenIcon: outlineBookOpenIcon,
  PencilSquareIcon: outlinePencilSquareIcon,
  TrashIcon: outlineTrashIcon,
  ArchiveBoxXMarkIcon: outlineArchiveBoxXMarkIcon,
  PhotoIcon: outlinePhotoIcon,
  EyeIcon: outlineEyeIcon,
  ChatBubbleLeftEllipsisIcon: outlineChatBubbleLeftEllipsisIcon,
  ClipboardDocumentListIcon: outlineClipboardDocumentListIcon,
  CalendarDaysIcon: outlineCalendarDaysIcon,
  EllipsisVerticalIcon: outlineEllipsisVerticalIcon,
  DocumentTextIcon: outlineDocumentTextIcon,
  CheckCircleIcon: outlineCheckCircleIcon,
  CheckIcon: outlineCheckIcon,
  Bars3CenterLeftIcon: outlineBars3CenterLeftIcon,
  MoonIcon: outlineMoonIcon,
  LockClosedIcon: outlineLockClosedIcon,
  XMarkIcon: outlineXMarkIcon,
  DocumentMagnifyingGlassIcon: outlineDocumentMagnifyingGlassIcon,
  EnvelopeIcon: outlineEnvelopeIcon,
  ArrowLeftIcon: outlineArrowLeftIcon,
  EyeSlashIcon: outlineEyeSlashIcon,
  HomeIcon: outlineHomeIcon,
  StarIcon: outlineStarIcon,
  ClockIcon: outlineClockIcon,
  PhoneIcon: outlinePhoneIcon,
  CameraIcon: outlineCameraIcon,
  MapPinIcon: outlineMapPinIcon,
  PaperAirplaneIcon: outlinePaperAirplaneIcon,
  ShieldCheckIcon: outlineShieldCheckIcon,
  InformationCircleIcon: outlineInformationCircleIcon,
  EllipsisHorizontalCircleIcon: outlineEllipsisHorizontalCircleIcon,
  PencilIcon: outlinePencilIcon,
  DocumentDuplicateIcon: outlineDocumentDuplicateIcon,
  ArrowRightIcon: outlineArrowRightIcon,
  BriefcaseIcon: outlineBriefcaseIcon,
  ChevronUpIcon: outlineChevronUpIcon,
  PaperClipIcon: outlinePaperClipIcon,
  MagnifyingGlassIcon: outlineMagnifyingGlassIcon,
  DocumentCheckIcon: outlineDocumentCheckIcon,
  PrinterIcon: outlinePrinterIcon,
  UserGroupIcon: outlineUserGroupIcon,
  IdentificationIcon: outlineIdentificationIcon,
  NewspaperIcon: outlineNewspaperIcon,
  ExclamationCircleIcon: outlineExclamationCircleIcon,
  Cog6ToothIcon: outlineCog6ToothIcon,
  SpeakerWaveIcon: outlineSpeakerWaveIcon,
  SpeakerXMarkIcon: outlineSpeakerXMarkIcon,
  MicrophoneIcon: outlineMicrophoneIcon,
};
